import { useEffect } from "react";
import { connect } from "react-redux";
import Select from "react-select";

import { storeActions } from "../../../redux/actions";
import { vendorDropdownStyle } from "../../../assets/scss/style";

const SelectStore = (props) => {
  const { user, value, stores, onChange, getStores, getOptions, isDisabled } =
    props;
  const handleGetOptions = () => {
    return stores.map((store) => ({
      label: store.storeName,
      value: store,
    }));
  };

  useEffect(() => {
    if (!stores || stores.length === 0) {
      getStores(user);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Select
        name="store"
        id="store"
        options={getOptions ? getOptions(stores) : handleGetOptions()}
        value={value}
        isSearchable={false}
        placeholder={"Select Store to connect with Shopify"}
        styles={vendorDropdownStyle}
        menuPortalTarget={document.body}
        onChange={onChange}
        isDisabled={isDisabled}
      />
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  stores: state.store.stores,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getStores: (data) => dispatch(storeActions.getStores(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectStore);
